module.exports = __webpack_public_path__ + "static/media/pic7.86bdbaa9.jpg";